import { useSearchParams } from 'react-router-dom';
import '../css/privacyterm.css'
import '../css/zizaits.css'

function Privacy() {
    const [searchParams] = useSearchParams();
    const language = searchParams.get('language') || '英文';

    document.body.className = 'policy';

    if (language === '中文') {
        return (
            <div className='zizaits-wrap'>
                <p>
                    欢迎使用「自在听书」（以下简称“本应用”）。本应用由广州野离子网络科技有限公司（以下简称“我们”）研发并运营，
                    是一款<strong>完全离线</strong>的小说阅读与听书工具。我们非常重视你的隐私。
                </p>
                <p>
                    本政策说明我们在你使用本应用时如何处理你的信息。简单来说：<strong>我们不收集、不上传、不追踪任何与你有关的数据</strong>。
                </p>

                <h3>一、我们不收集数据</h3>
                <ul>
                    <li><strong>无需注册：</strong>本应用没有账号系统，不收集姓名、手机号、邮箱等身份信息。</li>
                    <li><strong>书籍内容：</strong>你导入的书籍（txt / epub / md / pdf 等）只保存在你设备的App沙盒目录里，不会上传。</li>
                    <li><strong>阅读与听书记录：</strong>阅读进度、听书设置（发音人、音高、倍速）只写在本机偏好设置中，我们无法看到。</li>
                    <li><strong>无追踪：</strong>本应用不使用 IDFA，不会向你弹出「允许追踪」请求，也不会跨应用或跨网站追踪你。</li>
                    <li><strong>无分析：</strong>本应用未集成任何数据统计、崩溃上报、广告或推送 SDK。</li>
                </ul>

                <h3>二、设备权限</h3>
                <p>本应用只在必要时向系统申请以下权限，且均需你明确授权后才会使用：</p>
                <table border={1}>
                    <tr>
                        <td>权限</td>
                        <td>用途</td>
                        <td>涉及信息</td>
                    </tr>
                    <tr>
                        <td>文件与文稿（UIDocumentPicker）</td>
                        <td>导入本地书籍文件</td>
                        <td>你主动选取的文件，不上传</td>
                    </tr>
                    <tr>
                        <td>照片图库（NSPhotoLibraryUsageDescription）</td>
                        <td>保存客服二维码到相册</td>
                        <td>本地生成的一张图片，不上传</td>
                    </tr>
                    <tr>
                        <td>后台音频（UIBackgroundModes: audio）</td>
                        <td>听书在后台 / 锁屏时继续播放，并支持控制中心控制</td>
                        <td>不涉及个人信息</td>
                    </tr>
                    <tr>
                        <td>相机（NSCameraUsageDescription）</td>
                        <td>仅作工程声明，当前无任何功能调用，不读取任何影像</td>
                        <td>无</td>
                    </tr>
                </table>

                <h3>三、第三方组件与服务</h3>
                <p>
                    听书功能的语音合成由 Apple 系统自带的语音合成器（AVSpeechSynthesizer）完成，待朗读文本交给系统后立即在你设备上转换为语音，
                    全程离线，不会发送给 Apple 或任何其他第三方。
                </p>
                <p>除上述系统能力外，本应用不包含任何第三方统计、广告、推送、社交登录或支付模块。</p>

                <h3>四、数据存储与安全</h3>
                <p>
                    所有数据均保存在你的设备本地，受 iOS 沙盒机制保护。清空 App 数据或删除 App，会一并删除你导入的全部书籍与设置。
                    由于我们没有服务端，不需要也无法为你提供账号注销或数据下载服务。
                </p>

                <h3>五、你的权利</h3>
                <ul>
                    <li>你可以随时在系统「设置 → 通用 → iPhone 存储空间 → 自在听书」中卸载或删除数据。</li>
                    <li>你可以在系统「设置 → 隐私与安全性」中随时关闭已授予的任意权限。</li>
                    <li>你可以通过下方联系方式就隐私问题向我们提问。</li>
                </ul>

                <h3>六、未成年人保护</h3>
                <p>本应用不面向未满 14 周岁的儿童，我们不会有意收集未成年人的个人信息。</p>

                <h3>七、政策变更</h3>
                <p>如本政策发生变更，我们将在本应用中更新，并在 App Store 页面同步更新后的隐私政策链接。</p>

                <h3>八、联系我们</h3>
                <p>若你对本隐私政策有任何疑问或建议，欢迎与我们联系：</p>
                <ul>
                    <li>电子邮箱：pengdeshen_2013@qq.com</li>
                    <li>微信：yelizibiaoge（或打开应用「我的 → 联系我们」）</li>
                    <li>开发运营主体：广州野离子网络科技有限公司</li>
                </ul>
                <p>我们将在收到请求后 15 个工作日内答复。</p>

                <p>感谢你使用自在听书，我们将竭诚为你提供安全、纯净的离线阅读体验！</p>
                <p style={{ marginTop: '20px', fontSize: 14 }}>更新日期：2026年10月10日<br />生效日期：2026年10月10日</p>
            </div>
        )
    }

    return (
        <div className='zizaits-wrap'>
            <p>
                Welcome to 自在听书 / ZIZAITS (hereinafter referred to as "the App"). The App is developed and operated by
                Guangzhou Yelizi Network Technology Co., Ltd. (hereinafter referred to as "we"). It is a <strong>fully offline</strong> novel
                reading and audiobook tool, and we take your privacy seriously.
            </p>
            <p>
                This policy explains how we handle your information when you use the App. In short:
                <strong> we do not collect, upload, or track any data about you.</strong>
            </p>

            <h3>1. We Collect No Data</h3>
            <ul>
                <li><strong>No registration:</strong> The App has no account system and does not collect identity information such as your name, phone number, or email.</li>
                <li><strong>Book content:</strong> Books you import (txt / epub / md / pdf, etc.) are stored only in the App's sandbox directory on your device and are never uploaded.</li>
                <li><strong>Reading and listening records:</strong> Your reading progress and audiobook settings (voice, pitch, speed) are written to local preferences only. We cannot see them.</li>
                <li><strong>No tracking:</strong> The App does not use the Identifier for Advertisers (IDFA), never prompts you for tracking permission, and does not track you across apps or websites.</li>
                <li><strong>No analytics:</strong> The App integrates no data analytics, crash reporting, advertising, or push SDKs.</li>
            </ul>

            <h3>2. Device Permissions</h3>
            <p>The App requests the following permissions only when necessary, and only after you explicitly grant them:</p>
            <table className="menu" border={1}>
                <tr>
                    <td>Permission</td>
                    <td>Purpose</td>
                    <td>Information involved</td>
                </tr>
                <tr>
                    <td>Files and documents (UIDocumentPicker)</td>
                    <td>Importing local book files</td>
                    <td>Files you actively select; never uploaded</td>
                </tr>
                <tr>
                    <td>Photo library (NSPhotoLibraryUsageDescription)</td>
                    <td>Saving the support QR code to your album</td>
                    <td>One locally generated image; never uploaded</td>
                </tr>
                <tr>
                    <td>Background audio (UIBackgroundModes: audio)</td>
                    <td>Keeping audiobook playback running while backgrounded or locked, and allowing Control Center playback controls</td>
                    <td>No personal information</td>
                </tr>
                <tr>
                    <td>Camera (NSCameraUsageDescription)</td>
                    <td>Declared in the project but never invoked by any feature; no image is ever read</td>
                    <td>None</td>
                </tr>
            </table>

            <h3>3. Third-Party Components and Services</h3>
            <p>
                Speech synthesis for the audiobook feature is performed by Apple's built-in speech synthesizer (AVSpeechSynthesizer).
                The text to be read aloud is handed to the system and converted to speech entirely on your device, fully offline, and is
                never sent to Apple or any other third party.
            </p>
            <p>Apart from the system capability above, the App contains no third-party analytics, advertising, push, social login, or payment module.</p>

            <h3>4. Data Storage and Security</h3>
            <p>
                All data is stored locally on your device and protected by the iOS sandbox. Deleting the App removes every imported book and
                all settings. Because we run no server, we cannot offer — and do not need to offer — account deletion or data export services.
            </p>

            <h3>5. Your Rights</h3>
            <ul>
                <li>You may delete the App or its data at any time via Settings → General → iPhone Storage → 自在听书.</li>
                <li>You may revoke any granted permission at any time in Settings → Privacy & Security.</li>
                <li>You may contact us using the details below with any privacy-related question.</li>
            </ul>

            <h3>6. Protection of Minors</h3>
            <p>The App is not directed at children under 14, and we do not knowingly collect personal information from minors.</p>

            <h3>7. Changes to This Policy</h3>
            <p>If this policy changes, we will update it within the App and keep the privacy policy link on the App Store page up to date.</p>

            <h3>8. Contact Us</h3>
            <p>If you have any questions or suggestions about this policy, please reach out to us:</p>
            <ul>
                <li>Email: pengdeshen_2013@qq.com</li>
                <li>WeChat: yelizibiaoge (or open Profile → Contact Us in the App)</li>
                <li>Developer: Guangzhou Yelizi Network Technology Co., Ltd.</li>
            </ul>
            <p>We will respond within 15 working days of receiving your request.</p>

            <p>Thank you for using 自在听书. We are dedicated to providing you with a safe and pure offline reading experience!</p>
            <p style={{ marginTop: '20px', fontSize: 14 }}>Last updated: October 10, 2026<br />Effective date: October 10, 2026</p>
        </div>
    )
}

export default Privacy;
